import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';

import { Mensaje, MensajeSiNo } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
import useTable from '../../../useTable';
import { Toasts } from '../../../toasts';

import { Input } from '../../../../ui/inputs/Input';

import { PrimaryButton } from '../../../../ui/buttons/Button';
import { formatMoneda, parseMoneda } from '../../../../util/varios';
import Cargos from './Cargos';

const TablaCargos = (props) => {
    var op = require('../../../../modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const [mostrar, setMostrar] = useState(false);
    const [id, setId] = useState(0);
    const [operacionModal, setOperacionModal] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [idModal, setIdModal] = useState('');

    const headCells = [
        { id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' },
        { id: 'descripcion', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
        { id: 'grado', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'GRADO', textAlign: 'center' },
        { id: 'sueldo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'SUELDO', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' }
    ]

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const [mostrar2, setMostrar2] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(1);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const permiso = JSON.parse(localStorage.getItem('accbanco'))
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [nomina, setNomina] = useState();
    const [periodos, setPeriodos] = useState();

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                const query = target.value.toLowerCase();
                if (query === "") return items;

                return items.filter(x =>
                    (x.codcar?.toString().includes(query)) ||
                    (x.nomcar?.toLowerCase().includes(query)) ||
                    (x.grado?.toString().includes(query))
                );
            }
        });
    };

    const seleccionarRegistros = () => {
        let codigoNomina = localStorage.getItem('codigonomina');
        codigoNomina = codigoNomina.replace(/"/g, '');

        let campos = "TRIM(codcar) AS codcar , trim(grado) as grado, trim(nomcar) as nomcar, sueldo";
        let nomtab = `nomi${codigoNomina}.cargo`;
        let condi = props.condicion ? props.condicion : " 1=1 ";
        let orden = "codcar";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

        console.log(endpoint)

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    console.log(response.data)
                    setRecords(response.data);
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'Error', texto: error.response?.data?.message || error.message, icono: 'error' });
                setActivate(false);
            });
    };

    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }

    const seleccionarTipoNomina = (id) => {
        let campos = "*"
        let nomtab = "tiponomina";
        let nomid = "codnomi";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data.codnomi !== '') {
                    setNomina(response.data)
                    seleccionarPeriodo(response.data.codnomi);
                }
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response?.data?.message || error.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionarPeriodo = (codnomi) => {
        setActivate(true);

        let campos = "*";
        let nomtab = "periodos";
        let condi = "codnomi = '" + codnomi + "'";
        let orden = "numper";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data.length > 0) {
                    setPeriodos(response.data);
                    setMostrar2(true);
                }
            }
            setActivate(false)
        }).catch(function (error) {
            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response?.data?.message || error.message,
                icono: "error",
            });
            setActivate(false)
        })
    }

    const cerrarModal = () => {
        setMostrar2(false)
    }

    const gestionarTipoNomina = (op, id) => (e) => {
        e.preventDefault();
        setOperacionModal(op);
        if (op !== 1) {
            setIdModal(id);
        } else {
            setIdModal('');
        }
        setShowModal(true);
    }

    const recargarTabla = () => {
        seleccionarRegistros();
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    };

    useEffect(() => {
        seleccionarRegistros();
        setActivate(true);
    }, []);

    const cerrar = () => {
        props.setTabla(0)
    }

    return (
        <section className='col-8 m-0 p-0'>
            <header className='col-12 m-0 px-4 py-2 rounded-top d-flex align-items-center justify-content-between azulGradiant text-light'>
                <h3 className='m-0'>
                    Gestión de Cargos
                </h3>
                <a type='button' onClick={cerrar} className="text-light" style={{ cursor: 'pointer' }}>
                    Salir <i className="fas fa-times ms-2"></i>
                </a>
            </header>
            <form onSubmit={(e) => { e.preventDefault() }} className="d-flex justify-content-between p-2">
                <div className='col-4 m-0 p-0'>
                    <Input 
                        type="text"
                        ref={txtBuscador}
                        onChange={handleSearch}
                        placeholder="Buscar por código, descripción o grado" 
                    />
                </div>
                <PrimaryButton 
                    icon='fa-plus m-0'
                    disabled={permiso?.toString().substring(1, 2) !== '1'}
                    onClick={gestionarTipoNomina(1, '')}
                    title='Agregar Cargo'
                >
                    Agregar Cargo
                </PrimaryButton>
            </form>
            <div className="">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {
                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={index} style={{ padding: "0" }}>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.codcar}</td>
                                    <td className='align-baseline' style={{ textAlign: "left", alignItems: 'center' }}>{item.nomcar}</td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.grado}</td>
                                    <td className='align-baseline' style={{ textAlign: "right", alignItems: 'center', paddingRight: '10px' }}>
                                        {formatMoneda(item.sueldo?.toString().replace(',', '').replace('.', ','), ',', '.', 2)}
                                    </td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>
                                        <button 
                                            onClick={gestionarTipoNomina(4, item.codcar)} 
                                            className={permiso?.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Consultar"
                                            disabled={permiso?.toString().substring(0, 1) !== '1'}
                                        >
                                            <i className="fas fa-eye"></i>
                                        </button>
                                        {' '}
                                        <button 
                                            onClick={gestionarTipoNomina(2, item.codcar)} 
                                            className={permiso?.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Editar"
                                            disabled={permiso?.toString().substring(2, 3) !== '1'}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                        {' '}
                                        <button 
                                            onClick={gestionarTipoNomina(3, item.codcar)} 
                                            className={permiso?.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Eliminar"
                                            disabled={permiso?.toString().substring(3, 4) !== '1'}
                                        >
                                            <i className="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>

            <Cargos
                show={showModal}
               onHideCancelar={()=> setShowModal(false)}
                operacion={operacionModal}
                id={idModal}
                onRecargar={recargarTabla}
            />

            <Dimmer active={activate} inverted></Dimmer>
            <Mensaje 
                mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} 
            />
            <MensajeSiNo 
                mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} 
                onHideSi={handleCloseSi} 
            />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast} 
            />
        </section>
    );
}

export default TablaCargos;